import { EngagementMethods } from "./engagement";
import { StakingMethods } from "./staking";
import { StakingTokenMethods } from "./token";
export { EngagementMethods, StakingMethods, StakingTokenMethods };
export {
  ERC20Methods,
  ERC20MintableMethods,
  ERC20BurnableMethods,
  ERC20CappedMethods,
  ERC20PausableMethods,
} from "./token";

export default {
  ...EngagementMethods,
  ...StakingMethods,
  ...StakingTokenMethods,
};
